import { CrossIconBtn } from "assets/SVGs/SVGs";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getLastRefreshTimeInMinutes, getManualRefreshTime } from "utility";
import "./FrequentRequestPopup.css";

const FrequentRequestPopup = (props) => {
  const { show, setShow } = props;
  const [remainingTime, setRemainingTime] = useState(1);
  const {
    freeusIntervals,
    aneltoIntervals,
    clairvoyantIntervals,
    eViewIntervalArray,
  } = useSelector((store) => store?.devices);

  useEffect(() => {
    if (show) {
      const manualRefreshTime = getManualRefreshTime(
        props?.deviceType,
        aneltoIntervals,
        freeusIntervals,
        clairvoyantIntervals,
        eViewIntervalArray
      );
      const diffInMin = getLastRefreshTimeInMinutes(
        props?.lastRefreshTime,
        true
      );
      setRemainingTime(manualRefreshTime * 60 - diffInMin);
    }
  }, [show]);

  useEffect(() => {
    const timer = setInterval(() => {
      if (remainingTime > 0) {
        setRemainingTime(remainingTime - 1);
      }
      if (remainingTime <= 0) {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [remainingTime]);

  return (
    <Modal
      backdrop="true"
      aria-labelledby="contained-modal-title-vcenter"
      className="frp_container"
      show={show}
    >
      <Modal.Body className="frp_body">
        <div className="frp_close_icon_container">
          <CrossIconBtn
            className="frp_cross_icon"
            onClick={() => setShow({ isVisible: false })}
          />
        </div>
        <div className="frp_content_container">
          <p className="frp_description_text">
            {remainingTime > 0
              ? `Frequent requests can drain battery. You can refresh again in ${remainingTime} seconds.`
              : "You can refresh now."}
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FrequentRequestPopup;
